const DropdownConfig = {
  age: {
    min: 21,
    max: 70,
    values: [
      {
        value: "age",
        label: "Age",
        isDisabled: true,
      },
    ],
  },
  employmentStatus: [
    {
      value: "employmentStatus",
      label: "Employment Status",
      isDisabled: true,
    },
    { value: "Full-Time-Employed", label: "Full Time", },
    { value: "Other", label: "Other", },
  ],
  claimsHistory: [
    {
      value: "claimsHistory",
      label: "Claims History",
      isDisabled: true,
    },
    { value: "CLM12MTHS", label: "Claims in last 12 months", },
    { value: "NOCLM1YR", label: "No claims for 1 year", },
    { value: "NOCLM2YR", label: "No claims for 2 years", },
    { value: "NOCLM3YR", label: "No claims for 3 years", },
    { value: "NOCLM4YR", label: "No claims for 4 years", },
    { value: "NOCLM5YR", label: "No claims for 5+ years", },
  ],
  sex: [
    {
      value: "sex",
      label: "Sex",
      isDisabled: true,
    },
    { value: "M", label: "Male", },
    { value: "F", label: "Female", },
  ],
  namedDriverFor: [
    {
      value: "driving-experience",
      label: "Named Driver For",
      isDisabled: true,
    },
    { value: "UND1YR", label: "Under 12 Months", },
    { value: "PER1YR", label: "1 Year", },
    { value: "PER2YR", label: "2 Years", },
    { value: "PER3YR", label: "3 Years", },
    { value: "PER4YR", label: "4 Years", },
    { value: "PER5YR", label: "5 Years+", },
  ],
  firstTimeOwner: [
    {
      value: "firstTimeOwner",
      label: "First Time Vehicle Owner",
      isDisabled: true,
    },
    { value: true, label: "Yes", },
    { value: false, label: "No", },
  ],
  drivingExperience: [
    { value: "1-2-years", label: "1-2 Years", },
    { value: "3-4-years", label: "3-4 Years", },
    { value: "5-6-years", label: "5-6 Years", },
    { value: "7-plus-years", label: "7+ Years", },
  ],
  location: [
    {
      value: "location",
      label: "Select your location",
      isDisabled: true,
    },
    { value: "TT", label: "Trinidad & Tobago", },
    { value: "BA", label: "Barbados", },
    { value: "LE", label: "St. Lucia", },
    { value: "DE", label: "Dominica", },
  ],
  countryCodes: { TT: "868", BA: "246", LE: "758", DE: "767", GD: "473" },
  currencyCodes: { TT: "TTD", BA: "BBD", LE: "XCD", DE: "XCD", GD: "XCD" },
  vehicleUse: [
    {
      value: "vehicleUse",
      label: "Use",
      isDisabled: true,
    },
    { value: true, label: "Personal", },
    {
      value: false,
      label: "Business/Professional services",
    },
  ],
  engineSize: [
    { value: "engineSize", label: "Engine Size", isDisabled: true },
    { value: "Up to 1600", label: "Up to 1600" },
    { value: "1601 - 1800", label: "1601 - 1800" },
    { value: "Over 1800", label: "Over 1800" },
  ],
  vehicleType: [
    { value: "vehicleType", label: "Type", isDisabled: true, },
    { value: "Sedan-SUV", label: "Sedan/SUV", },
    { value: "Pick-up", label: "Pick-up", },
  ],
  dateOfManufacture: [
    {
      value: "dateOfManufacture",
      label: "Date of Manufacture",
      isDisabled: true,
    },
    { value: "Within-Last-7-Years", label: "Within last 7 years", },
    { value: "Over-8-Years", label: "8+ Years", },
  ],
  antiTheftSystem: [
    {
      value: "antiTheftSystem",
      label: "Anti Theft System",
      isDisabled: true,
    },
    { value: "NONE", label: "None", },
    { value: "ANTIIMMO", label: "Alarm / Immobilizer", },
    {
      value: "ANTISRCH",
      label: "Alarm/GPS/Recovery (Car Search)",
    },
  ],
  coverType: [
    { value: "coverType", label: "Cover Type", isDisabled: true, },
    { value: "T", label: "Third Party", },
    { value: "C", label: "Comprehensive", },
  ],
};

let min = DropdownConfig.age.min;
let max = DropdownConfig.age.max;

for (min; min <= max; min++) {
  DropdownConfig.age.values.push({ value: `${min}`, label: `${min}`, });
}

export default DropdownConfig;



// WEBPACK FOOTER //
// ./src/modules/dropdownConfig.js